import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangePhoneLazy = lazyLoader(
  () => import('./ChangePhone' /* webpackChunkName: "change-phone" */),
);

const ChangePhone = () => {
  return (
    <Suspense fallback={null}>
      <ChangePhoneLazy />
    </Suspense>
  );
};

export default ChangePhone;
